<script setup lang="ts">
import useMarkdown from '@/composables/useMarkdown'
import { computed } from 'vue'
/* eslint-disable vue/no-v-html */

const props = defineProps<{
  text?: string
  clipAround?: number
}>()

const { parseMarkdown } = useMarkdown()
const clippedText = computed(() => {
  if (!props.text || !props.clipAround) {
    return props.text
  }
  if (props.clipAround >= props.text.length) {
    return props.text
  }

  return props.text.substring(0, props.text.indexOf(' ', props.clipAround - 5)) + '...'
})
</script>

<template>
  <div class="markdownText" v-html="parseMarkdown(clippedText)" />
</template>

<style lang="scss">
.markdownText {
  font-size: calc(1rem * var(--operator-font-scale, 1));

  p {
    margin-bottom: 1em;
  }
  h1 {
    font-size: 1.5em;
  }
  h2 {
    font-size: 1.3em;
  }
  h3 {
    font-size: 1.15em;
  }
  h4,
  h5,
  h6 {
    font-size: 1em;
  }
  ul,
  ol {
    padding-left: 1.5em;
    margin-bottom: 1em;
  }
  ul {
    list-style: disc;
  }
  ol {
    list-style: decimal;
  }
  li > p {
    margin-bottom: 0;
  }
}
</style>
